export enum PermissionType {
  Base = 'CPM',
  Video = 'VID',
  Tutorial = 'TUT',
  Note = 'NTE',
  LegacyExam = 'EXM',
  ClassQuiz = 'CQZ',
}

export enum PermissionSource {
  Direct = 'DIRECT',
}

/** Where a user's permission comes from: shared with them, or with a group they are in. */
export enum PermissionSourceType {
  Direct = 'direct',
  Custom = 'custom',
  Class = 'class',
}
